// extracted by mini-css-extract-plugin
export default {"imageWidget":"image-module__imageWidget--kqKTV"};